import { render } from "./Menu.vue?vue&type=template&id=0a93b634&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0a93b634&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a93b634"

export default script